import { Button, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../../api/axios";
import { toast } from "react-toastify";
import { APP_URLS } from "../../../api/url";
import { ThreeDots } from "react-loader-spinner";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import { APIError } from "../../../core/utils";
import Cancel from "../../../assets/Images/icons/Cancel.svg";
import { PaginationWrapper } from "../../../assets/SharedComponents/Pagination/style/PaginationWrapper";
import { ModalWrapper } from "../style/style";
import { AdReportStatus } from "../../../config/constant";
import moment from "moment";

const ReportHistoryModal = ({ title, id }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loaded, _loaded] = useState(false);

  const [history, _history] = useState([]);

  const [totalPage, _totalPage] = useState(0);
  const [total, _total] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!open) {
      setPage(1);
      return;
    }
    const getHistory = async () => {
      _loaded(true);
      try {
        const res = await API.get(
          `${APP_URLS.REPORTED_ADS}/${id}${APP_URLS.REPORTED_ADS_HISTORY}?page=${page}`
        );
        const { data: resp } = res;
        if (resp.success) {
          _history(resp?.data?.data ?? []);
          _totalPage(resp?.data?.last_page ?? 1);
          _total(resp?.data?.total ?? 0);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } finally {
        _loaded(false);
      }
    };
    getHistory();
  }, [open, page]);

  return (
    <>
      <Button onClick={handleOpen} className="link">
        View
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalWrapper>
          <h3>{title}</h3>
          <img src={Cancel} alt="" className="closeButton" onClick={handleClose} />
          <div>
            <span>
              Total Records : <b>{total}</b>
            </span>
          </div>
          <div className="tableContainer">
            <table className="modalTable">
              <thead className="tableHead">
                <tr className="table-row">
                  <th>
                    User ID/
                    <br /> Subsidiary ID
                  </th>
                  <th>Reported by</th>
                  <th>Reason</th>
                  <th>Create date</th>
                  <th>Status</th>
                  <th>Action taken by</th>
                </tr>
              </thead>
              {loaded ? (
                <div className="d-flex justify-content-center three-dot">
                  <ThreeDots
                    height="150"
                    width="150"
                    radius="9"
                    color="#637df4"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <tbody>
                  {history && history.length > 0 ? (
                    history.map((report, index) => {
                      return (
                        <tr
                          class="table-row"
                          key={`history-${report.id}-${index}`}
                        >
                          <td>
                            <a
                              href={`${report.source === "subsidiary"
                                ? "/company-details"
                                : "/detail-member"
                                }/${report.user_id}`}
                              className="link"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <b>{report.user_id}</b>
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${report.source === "subsidiary"
                                ? "/company-details"
                                : "/detail-member"
                                }/${report.user_id}`}
                              className="link"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <b>{report?.user_name ?? "-"}</b>
                            </a>
                          </td>
                          <td>{report.reason_text}</td>
                          <td>
                            {moment(report.created_at)
                              .tz("Europe/Amsterdam")
                              .format("DD-MM-YYYY HH:mm")}
                          </td>
                          <td>
                            <span className={AdReportStatus[report.status]}>
                              {AdReportStatus[report.status]}
                            </span>
                          </td>
                          <td>{report.action_by_name}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>
              )}
            </table>
          </div>
          {totalPage > 1 ? (
            <PaginationWrapper
              totalPages={totalPage}
              onPageClick={(page) => setPage(page + 1)}
              key={totalPage}
            />
          ) : (
            ""
          )}
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ReportHistoryModal;
